import React from "react";
import { AlertCircle } from "lucide-react";
import { POLICIES } from "@/data/site";

/**
 * Bold, impossible-to-miss booking policies block.
 * Used on the Home page and above the scheduler on the Book page.
 */
export default function Policies({ id, compact = false }) {
  if (!POLICIES.length) return null;
  return (
    <div
      id={id}
      className="relative border-2 border-gold bg-gradient-to-b from-charcoal to-onyx shadow-[0_0_40px_-12px_rgba(212,175,55,0.5)]"
    >
      <div className={compact ? "p-6 sm:p-7" : "p-7 sm:p-10"}>
        <div className="flex items-center gap-3">
          <AlertCircle className="shrink-0 text-gold" size={compact ? 24 : 28} />
          <h2
            className={`font-display uppercase tracking-[0.15em] text-gold ${
              compact ? "text-xl sm:text-2xl" : "text-2xl sm:text-3xl"
            }`}
          >
            Booking Policies
          </h2>
        </div>
        <ul className="mt-6 space-y-5">
          {POLICIES.map((p, i) => (
            <li key={i} className="border-l-2 border-gold/70 pl-4">
              <p className="text-[0.72rem] font-semibold uppercase tracking-[0.22em] text-gold">
                {p.title}
              </p>
              <p className="mt-1.5 text-base sm:text-lg font-semibold leading-relaxed text-ivory">
                {p.text}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
